import React, { FC } from 'react';

import { Card, CardContent, Box, Divider, Grid, Link, Typography } from '@mui/material';

import WebIcon from '@mui/icons-material/Web';

import { BackflowJobGroup } from '../../model';

interface OnlinePortalDisplayProps {
  backflowJobGroup: BackflowJobGroup;
}

const OnlinePortalDisplay: FC<OnlinePortalDisplayProps> = (props) => {
  const { backflowJobGroup } = props;

  if (!backflowJobGroup.online_portal_url) {
    return null;
  }

  return (
    <Card elevation={3}>
      <CardContent>
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" mb={2}>
            <WebIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6" fontWeight="600">
              Online Portal
            </Typography>
          </Box>
          <Divider sx={{ mb: 1 }} />
        </Grid>
        <Grid item xs={12}>
          <Link href={backflowJobGroup.online_portal_url} target="_blank" rel="noopener noreferrer">
            {backflowJobGroup.online_portal_url}
          </Link>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default OnlinePortalDisplay;
